import React, { FC } from 'react';
import { IServiceKycResponse } from '@shared/api';
import { BsCheck, BsExclamationTriangle } from 'react-icons/bs';
import './KYCResponse.scss';

const responseData = {
    RisksDetected: {
        title: 'Risks detected',
        icon: <BsExclamationTriangle />,
        styles: {
            backgroundColor: '#FFF7ED',
            color: '#C2410C',
            borderColor: '#FFEDD5',
        },
    },
    Failed: {
        title: 'KYC Verification Failure',
        icon: <BsExclamationTriangle />,
        styles: {
            backgroundColor: '#FCF1F1',
            color: '#B91C1C',
            borderColor: '#FEE2E2',
        },
    },
    Passed: {
        title: 'Customer has passed KYC verification',
        icon: <BsCheck />,
        styles: {
            backgroundColor: '#ECFDF6',
            color: '#047857',
            borderColor: '#CEF5E6',
        },
    },
};

interface IKYCResponseProps {
    response: IServiceKycResponse;
}

export const KYCResponse: FC<IKYCResponseProps> = ({ response }) => {
    const currentResponse = responseData[response.result];
    return (
        <div className='kyc-response'>
            <div className='kyc-response__title'>
                <div style={currentResponse.styles}>{currentResponse.icon}</div>
                <h5>{currentResponse.title}</h5>
            </div>
            {response.result === 'Passed' ? (
                <p className='kyc-response__info-success'>KYC provider detected no issues with the applicant's data</p>
            ) : (
                <div className='kyc-response__info-item'>
                    <span className='kyc-response__info-item__header'>Error:</span>
                    <span className='kyc-response__info-item__value'>{response.message}</span>
                </div>
            )}
        </div>
    );
};
